<!-- Modal Backdrop -->
<div 
  *ngIf="showModal"
  class="fixed inset-0 z-[9999] overflow-y-auto bg-black bg-opacity-50 flex items-center justify-center p-4"
  (click)="closeModal()"
>
  <!-- Modal Content -->
  <div
    (click)="$event.stopPropagation()"
    class="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-hidden flex flex-col"
  >
    <!-- Clean White Header with Border -->
    <div class="bg-white border-b border-gray-100 px-6 py-4 flex items-center justify-between">
      <div class="flex items-center gap-3">
        <div class="w-8 h-8 bg-orange-50 rounded-full flex items-center justify-center text-orange-500">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-4 h-4">
            <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3" />
          </svg>
        </div>
        <h2 class="text-xl font-bold text-gray-900">{{ 'Wybierz opcje' | translate }}</h2>
      </div>
      <button
        (click)="closeModal()"
        class="w-8 h-8 rounded-full hover:bg-gray-100 flex items-center justify-center transition-colors text-gray-400 hover:text-gray-600"
      >
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-4 h-4">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <!-- Modal Body -->
    <div class="flex-1 overflow-y-auto p-6">
      <!-- No paid downloads available -->
      <div *ngIf="!hasDownloadsWithPrice()" class="text-center py-8">
        <div class="w-16 h-16 mx-auto mb-4 bg-gray-100 rounded-full flex items-center justify-center">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-8 h-8 text-gray-400">
            <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
          </svg>
        </div>
        <p class="text-gray-600 text-lg">{{ 'Brak płatnych materiałów do pobrania' | translate }}</p>
        <p class="text-gray-500 text-sm mt-1">{{ 'Wszystkie materiały do tego produktu są bezpłatne i dostępne bezpośrednio.' | translate }}</p>
      </div>

      <!-- Show only paid downloads -->
      <div *ngIf="hasDownloadsWithPrice()" class="space-y-6">
        <div class="bg-gradient-to-r from-orange-50 to-yellow-50 border border-orange-200 rounded-lg p-4 mb-6">
          <div class="flex items-start gap-3">
            <div class="w-6 h-6 bg-orange-500 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="white" class="w-3 h-3">
                <path stroke-linecap="round" stroke-linejoin="round" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <div>
              <h3 class="text-sm font-semibold text-orange-800 mb-1">{{ 'Usługi dodatkowe' | translate }}</h3>
              <p class="text-sm text-orange-700">{{ 'Możesz wybrać dodatkową usługę dla produktu' | translate }} <strong>{{ productName }}</strong>{{ '. Usługi są opcjonalne — produkt możesz dodać do koszyka z usługą lub bez niej.' | translate }}</p>
            </div>
          </div>
        </div>

        <div *ngFor="let download of downloads" class="space-y-3">
          <!-- Only show download categories that have paid items -->
          <ng-container *ngIf="hasPaidDownloadsInCategory(download)">
            <h3 class="text-lg font-semibold text-gray-900 border-b border-gray-200 pb-2">
              {{ 'Usługi dodatkowe i opcje:' | translate }}
            </h3>
            
            <div class="space-y-2">
              <ng-container *ngFor="let value of download.values; let i = index">
                <div 
                  *ngIf="isPaidDownload(value)"
                  class="flex items-center justify-between p-4 border border-gray-200 rounded-lg hover:border-orange-300 hover:bg-orange-50 transition-all duration-200"
                  [class.border-orange-400]="value.selected"
                  [class.bg-orange-50]="value.selected"
                >
                  <div class="flex items-center gap-3 flex-1 min-w-0">
                    <input
                      type="checkbox"
                      [id]="'download-' + download.id + '-' + i"
                      [checked]="value.selected"
                      (change)="toggleDownload(download, value)"
                      class="w-4 h-4 text-orange-600 bg-gray-100 border-gray-300 rounded focus:ring-orange-500 focus:ring-2 flex-shrink-0"
                    />
                    <label [for]="'download-' + download.id + '-' + i" class="flex items-center gap-3 cursor-pointer flex-1 min-w-0">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-5 h-5 text-red-500 flex-shrink-0">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
                      </svg>
                      <div class="flex-1 min-w-0">
                        <div class="font-medium text-gray-900 break-words">{{ value.name | translate }}</div>
                      </div>
                    </label>
                  </div>
                  
                  <div class="flex items-center gap-2 ml-4 flex-shrink-0">
                    <span class="text-lg font-bold text-orange-600 whitespace-nowrap">
                      {{ (value.price || 0) | appendCurrency }}
                    </span>
                  </div>
                </div>
              </ng-container>
            </div>
          </ng-container>
        </div>
      </div>
    </div>

    <!-- Modal Footer - Only show when there are paid downloads -->
    <div *ngIf="hasDownloadsWithPrice()" class="border-t border-gray-200 px-6 py-4 bg-gray-50">
      <div class="flex items-center justify-between mb-4">
        <div class="text-sm text-gray-600">
          {{ 'Liczba wybranych materiałów do pobrania:' | translate }} <span class="font-medium">{{ selectedDownloads.length }}</span>
        </div>
        <div class="text-xl font-bold text-gray-900">
          {{ 'Razem:' | translate }} <span class="text-orange-600">{{ getTotalPrice() | appendCurrency }}</span>
        </div>
      </div>
      
      <div class="flex gap-3">
        <button
          (click)="confirmSelectionWithoutDownloads()"
          class="flex-1 px-4 py-3 bg-gray-200 text-gray-800 font-medium rounded-lg hover:bg-gray-300 transition-colors"
        >
          {{ 'Dodaj tylko produkt' | translate }}
        </button>
        <button
          (click)="confirmSelection()"
          class="flex-1 px-4 py-3 font-medium rounded-lg transition-colors"
          [class]="selectedDownloads.length > 0 
            ? 'bg-orange-500 text-white hover:bg-orange-600' 
            : 'bg-orange-500 text-white hover:bg-orange-600'"
        >
          <span *ngIf="selectedDownloads.length === 0">{{ 'Dodaj tylko produkt' | translate }}</span>
          <span *ngIf="selectedDownloads.length > 0">{{ 'Dodaj z usługami (' | translate }}{{ getTotalPrice() | appendCurrency }})</span>
        </button>
      </div>
    </div>

    <!-- Footer for no paid downloads -->
    <div *ngIf="!hasDownloadsWithPrice()" class="border-t border-gray-200 px-6 py-4 bg-gray-50">
      <button
        (click)="confirmSelection()"
        class="w-full px-4 py-3 bg-orange-500 text-white font-medium rounded-lg hover:bg-orange-600 transition-colors"
      >
        {{ 'Dodaj produkt do koszyka' | translate }}
      </button>
    </div>
  </div>
</div>
